/*
 * @Description: nav切换
 * @Author: yy
 * @LastEditors: yy
 * @Date: 2019-02-19 14:14:21
 * @LastEditTime: 2019-03-01 17:29:10
 */

import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './ExportNav.css';

class ExportNav extends React.Component {
  constructor () {
    super();

    this.state = {
      current: 0
    }
  }

  /**
   * 切换标题
   * @param {*} index
   * @param {*} query
   * @memberof ExportNav
   */
  toggle (index, query) {
    this.setState({
      current: index
    });
    const clickHandle = this.props.clickHandle;
    clickHandle && clickHandle(query)
  }

  render () {
    const {list} = this.props;
    const current = this.state.current;
    return (
      <div className={s.container}>
        {
          list.map((item, index) => {
            return (
              <div
                className={current === index ? s.isActive : ''}
                style={item.color ? {color: item.color} : {}}
                onClick={() => {this.toggle(index, item)}}
                key={item.key}
              >
                {item.name}
              </div>
            );
          })
        }
      </div>
    
    )
  }
}

export default withStyles(s)(ExportNav);


// WEBPACK FOOTER //
// src/components/ExportNav/ExportNav.js